import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useStateContext } from "../../../../contexts/ContextProvider";
import { ShowTableKoreksiStokToko } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../../components";
import { postRequest } from "../../../../constants/api";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const TampilKoreksiStokToko = () => {
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [tanggalKoreksiStokToko, setTanggalKoreksiStokToko] = useState("");
  const [kodeBarang, setKodeBarang] = useState("");
  const [namaBarang, setNamaBarang] = useState("");
  const [kuantitasStok, setKuantitasStok] = useState("");
  const [perubahanKuantitasStok, setPerubahanKuantitasStok] = useState("");
  const [harga, setHarga] = useState("");
  const [subtotalKoreksiStokToko, setSubtotalKoreksiStokToko] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [koreksiStokTokos, setKoreksiStokTokos] = useState([]);
  const [koreksiStokTokosPagination, setKoreksiStokTokosPagination] = useState(
    []
  );
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");
  const PER_PAGE = 20;

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    id && getKoreksiStokTokoById();
  }, [id]);

  useEffect(() => {
    getKoreksiStokTokosPagination();
  }, [page, searchTerm]);

  const getKoreksiStokTokosPagination = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        `/koreksiStokTokosPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {},
        navigate,
        dispatch
      );
      setQuery(searchTerm);
      setKoreksiStokTokosPagination(response.data.koreksiStokTokos);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (err) {
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getKoreksiStokTokos = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        `/koreksiStokTokos`,
        {},
        navigate,
        dispatch
      );
      setKoreksiStokTokos(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getKoreksiStokTokoById = async () => {
    if (id) {
      setLoading(true);
      const response = await postRequest(
        `/koreksiStokTokos/${id}`,
        {},
        navigate,
        dispatch
      );
      setTanggalKoreksiStokToko(response.data.tanggalKoreksiStokTokoFormatted);
      setKodeBarang(response.data.barang.kodeBarang);
      setNamaBarang(response.data.namaBarang);
      setKuantitasStok(response.data.kuantitasStok);
      setPerubahanKuantitasStok(response.data.perubahanKuantitasStok);
      setHarga(response.data.harga.toLocaleString("en-US"));
      setSubtotalKoreksiStokToko(
        response.data.subtotalKoreksiStokToko.toLocaleString("en-US")
      );
      setKeterangan(response.data.keterangan);
      setLoading(false);
    }
  };

  const deleteKoreksiStokToko = async (id) => {
    setLoading(true);
    try {
      await postRequest(`/deleteKoreksiStokToko/${id}`, {}, navigate, dispatch);
      setSearchTerm("");
      setTanggalKoreksiStokToko("");
      setKodeBarang("");
      setNamaBarang("");
      setKuantitasStok("");
      setPerubahanKuantitasStok("");
      setHarga("");
      setSubtotalKoreksiStokToko("");
      setKeterangan("");
      getKoreksiStokTokosPagination();
      navigate("/koreksiStokToko");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${kuantitasStok} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Koreksi Stok Toko`, 80, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    doc.save("daftarKoreksiStokToko.pdf");
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "KoreksiStokToko",
    sheet: "DaftarKoreksiStokToko",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Stok</h3>
      <h5 style={{ fontWeight: 400 }}>Koreksi Stok Toko</h5>
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getKoreksiStokTokos();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getKoreksiStokTokos();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="styled-table" id="table" style={{ fontSize: "10px" }}>
            <thead>
              <tr>
                <th>Tgl.</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Stok Awal</th>
                <th>Koreksi</th>
                <th>Stok Akhir</th>
                <th>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {koreksiStokTokos.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.tanggalKoreksiStokTokoFormatted}</td>
                  <td>{user.barang.kodeBarang}</td>
                  <td>{user.namaBarang}</td>
                  <td>{user.kuantitasStok}</td>
                  <td>{user.perubahanKuantitasStok}</td>
                  <td>{user.kuantitasStok + user.perubahanKuantitasStok}</td>
                  <td>{user.keterangan}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table
          class="styled-table"
          id="table"
          style={{ fontSize: "10px" }}
          ref={tableRef}
        >
          {previewExcel && (
            <tbody>
              <tr>
                <th>Tgl.</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Stok Awal</th>
                <th>Koreksi</th>
                <th>Stok Akhir</th>
                <th>Keterangan</th>
              </tr>
              {koreksiStokTokos.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.tanggalKoreksiStokTokoFormatted}</td>
                  <td>{user.barang.kodeBarang}</td>
                  <td>{user.namaBarang}</td>
                  <td>{user.kuantitasStok}</td>
                  <td>{user.perubahanKuantitasStok}</td>
                  <td>{user.kuantitasStok + user.perubahanKuantitasStok}</td>
                  <td>{user.keterangan}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/koreksiStokToko/tambahKoreksiStokToko`}
          editLink={null}
          deleteUser={deleteKoreksiStokToko}
          nameUser={kuantitasStok}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Koreksi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={tanggalKoreksiStokToko}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Barang :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kodeBarang} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Barang :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={namaBarang} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Stok Awal :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kuantitasStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Koreksi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={perubahanKuantitasStok}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Stok Awal :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={kuantitasStok + perubahanKuantitasStok}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Harga :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={harga} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Subtotal :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={subtotalKoreksiStokToko}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableKoreksiStokToko currentPosts={koreksiStokTokosPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilKoreksiStokToko;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
